import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import './DynamicInputField.css';
import { convertCase } from '../Helper/utils';
const DynamicInputField = ({
  inputfieldLabel,
  disabled = false,
  reset = null,
  setInputValue,
  inputValue
}) => {


  
const handleChange = (e, field) => {
  const value = e.target.value;
  setInputValue((prevValue) => {
    const updatedValue = {
      ...prevValue,
      [field]: value, // Set value for the specific field
    };

    // Update localStorage with the new inputValue
    sessionStorage.setItem('CustomerDetails', JSON.stringify(updatedValue));

    return updatedValue;
  });
};
  // console.log("reset :", reset);
  
  // useEffect(() => {
  //   if (reset === null) {
  //     setInputValue('');
  //   }
  // }, [reset]);

  return (
    <div className="input-field-container">
    {inputfieldLabel &&
      inputfieldLabel?.map((field, index) => (
        <TextField
          key={index}
          className="dynamic-input-field"
          label={convertCase(field)}
          value={inputValue[field] || ''} 
          onChange={(e) => handleChange(e, field)} // Pass the field name to handleChange
          variant="standard"
          autoComplete="off"
          disabled={disabled}
        />
      ))}
  </div>
  
  );
};

export default DynamicInputField;
